import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Footer, ScrollToTop } from 'src/components';
import routes from './routes';
import { NotFound } from './views';
import AOS from 'aos';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-leaflet-markercluster/dist/styles.min.css';
import 'react-tabs/style/react-tabs.css';
import "aos/dist/aos.css";

const App = () => {
    useEffect(() => {
        AOS.init({
            duration: 1200,
            once: true
        })
    }, [])
    return (
        <div className="page">
            <ScrollToTop />
            <Router>
                <Switch>
                    {routes.map(({ path, name, Component, exact }, key) => (
                        <Route
                            exact={exact}
                            path={path}
                            key={key}
                            render={props => {
                                const crumbs = routes
                                    .filter(({ path }) => props.match.path.includes(path))
                                    .map(({ path, ...rest }) => ({
                                        path: Object.keys(props.match.params).length
                                            ? Object.keys(props.match.params).reduce(
                                                (path, param) => path.replace(
                                                    `:${param}`, props.match.params[param]
                                                ), path
                                            )
                                            : path,
                                        ...rest
                                    }));
                                return (
                                    <Component {...props} crumbs={crumbs} />
                                );
                            }}
                        />
                    ))}
                    <Route component={NotFound} />
                </Switch>
            </Router>
            <Footer />
        </div>
    );
}

export default App;
